/* eslint-disable max-classes-per-file */

/* eslint-disable jsx-a11y/label-has-associated-control */
/* wg. Floating Labels von PrimeReact */

/*
Item: Form to display saved tables, rules, mm
Name: TablesSaved
Format: Frontend component, partial screen
*/

import React from 'react';
import { Growl } from 'primereact/growl';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { TabPanel } from 'primereact/tabview';
import { InputText } from 'primereact/components/inputtext/InputText';
// import { TreeTable } from 'primereact/treetable';
import JsonHelper, {
  TableSavedNames, TypeNames, TypeNumbers, changeVariables,
} from '../utils/statisticsUtils';
import MessageService from '../service/MessageService';
import NodeService from '../service/NodeService';
import TablesSavedDialog from '../components/dialogue/TablesSavedDialog';
import ValueDialogRead from '../components/dialogue/ValueDialogRead';
import { MultiLanguage } from '../utils/MultiLanguage';
import FolderDialog, { FolderDialogTypes } from '../components/dialogue/FolderDialog';
import { TreeTable } from 'primereact/treetable';

function convertToSortable(convertTime) {
  let d = '';
  if (convertTime) {
    // correct time to local
    const year = convertTime.substring(6, 10);
    const month = convertTime.substring(3, 5);
    const day = convertTime.substring(0, 2);
    const time = convertTime.substring(11, 19);
    // const dateString = `${month} ${day} ${year} ${time} GMT`;
    d = `${year}-${month}-${day} ${time}`;
  }
  return d;
}

const dispType = Object.freeze({
  VARIABLE: 'Merkmal',
  VALUE_VARIABLE: 'Wertmerkmal',
  CLASSIFYING_VARIABLE: 'Klassifizierendes Merkmal',
  TIME_IDENTIFYING_VARIABLE: 'zeitlich identifizierendes Markmal',
  TIME_IDENTIFYING: 'zeitlich identifizierend',
  TIME_CLASSIFYING: 'zeitlich klassifizierend',
  REGION_CLASSIFYING: 'räumlich klassifizierend',
  SUBJECT_CLASSIFYING: 'sachlich klassifizierend',
  SUBJECT_CLASSIFYING_TOTAL: 'Sachklassifizierend Insgesamt',
  REFERENCE: 'Referenz',
  ALGORITHM: 'Algorithmus',
  HIERARCHY: 'Hierarchie',
});

const dispMeasurement = Object.freeze({
  QUANTITY: 'Anzahl',
});

const DialogType = Object.freeze({
  none: 0,
  delete: 1,
  rename: 2,
  copyItem: 3,
  switchLoc: 4, // switch location
  moveItem: 5,
  propertiesAr: 6, // Agorithm Rule
  propertiesHr: 7, // Hierachical Rule
  propertiesRr: 8, // Reference Rule
});

const ruleType = Object.freeze({
  ALGORITHM: 6,
  HIERARCHY: 7,
  REFERENCE: 8,
});

export default class TablesSaved extends React.Component {
  constructor(props) {
    super(props);
    this.closeDialogue = this.closeDialogue.bind(this);
    this.state = {
      // Bund? Land?
      group: sessionStorage.getItem('group'),
      // type of current editDialog
      currentDialogType: DialogType.none,
      // currentSelectedNode in TreeTable
      currentNode: undefined,
      // new Name for renameing or creating node
      newNodeDataName: undefined,
      // allNodes
      allNodes: [],
      // key of the node which is selected as new father node in the edit dialog
      selectedTreeNodeKey: undefined,
      // state for wait spinner dialog
      visibleWait: true,
      // entry in properties
      entry1: {},
      // name in dialog
      nodeName: '',

      isNewFolderDialogOpen: false,

      folderInit: undefined,

      newFolderName: '',

      folderDialogType: 0,

      folders: [],

      folderAssociationInit: undefined,

      foldersLoading: false,

      expandedKeys: []
    };
    this.messageService = new MessageService();
    this.multiLanguage = new MultiLanguage();
    this.nodeservice = new NodeService();
    this.actionTemplate = this.actionTemplate.bind(this);
    this.confirmDialog = this.confirmDialog.bind(this);
    this.getDirectory = this.getDirectory.bind(this);
    this.onHide = this.onHide.bind(this);
    this.setNewNodeDataName = this.setNewNodeDataName.bind(this);
    this.loadNode = this.loadNode.bind(this);
    this.launchStatistics = this.launchStatistics.bind(this);
    this.onFolderDialogConfirm = this.onFolderDialogConfirm.bind(this)
    this.onFolderExpand = this.onFolderExpand.bind(this)
    this.openFolderDialog = this.openFolderDialog.bind(this)
    this.loadSubFoldersAndTables = this.loadSubFoldersAndTables.bind(this)
  }

  componentDidMount = async () => {
    try {
      await this.loadStatisticList();
      const statistic = window.location.href.split('&')[1];
      const right = TableSavedNames[statistic][2];
      let type = 'rule';
      let objectTyp = 'RULE';
      let objectNumber = '34'; // VARIABLE=3, RULE=34, STRUCTURE=108
      let prefix = '2';
      let typeString = 'Regel';
      const children2 = await this.getDirectory(type, right, objectNumber, objectTyp, prefix,
        typeString);
      type = 'variable';
      objectTyp = 'VARIABLE'; // VALUE_VARIABLE
      objectNumber = '3';
      prefix = '0';
      typeString = 'Wert';
      const children0 = await this.getDirectory(type, right, objectNumber, objectTyp, prefix,
        typeString);
      type = 'structure';
      objectTyp = 'STRUCTURE';
      objectNumber = '108';
      prefix = '1';
      const children1 = await this.getDirectory(type, right, objectNumber, objectTyp, prefix,'', [
        {
          '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
          type: 'FOLDER',
          name: null,
          reference: null,
          id: -1,
          shortDescription: '',
          idList: [],
        }
      ]);


      const folderInit = await this.messageService.postFolderInit()
      this.setState({ folderInit })

      const folderAssociationInit = await this.messageService.postFolderAssociationInitInit()
      this.setState({ folderAssociationInit })

      const tableFolders = await this.getDirectory('folder', right, 190, 'FOLDER', prefix,'', [
        {
          '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
          type: 'FOLDER',
          name: null,
          reference: null,
          id: -1,
          shortDescription: '',
          idList: [],
        }
      ])
      tableFolders.forEach(folder => {
        if(folder.data.folderCount > 0 || folder.data.structureCount > 0)
          folder.leaf = false//[{...folder, key: 'dummy'}]
      })

      this.setState({folders: tableFolders})

      await this.nodeservice.getTreeTableNodes('assets/foldernodes.json').then((data) => this.setState({ allNodes: data }));
      const { allNodes } = this.state;
      allNodes[0].children = children0;
      allNodes[1].children = [...tableFolders, ...children1];
      allNodes[2].children = children2;
      this.setState({ allNodes });
    } catch (e) {
      console.log('error in componentDidMount', e);
    } finally {
      this.setState({ visibleWait: false });
    }
  }


  async reloadTablesAndFolders() {
    const statistic = window.location.href.split('&')[1];
    const right = TableSavedNames[statistic][2];
    const type = 'structure';
    const objectTyp = 'STRUCTURE';
    const objectNumber = '108';
    const prefix = '1';
    const {allNodes} = this.state;
    const children1 = await this.getDirectory(type, right, objectNumber, objectTyp, prefix,'', [
      {
        '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
        type: 'FOLDER',
        name: null,
        reference: null,
        id: -1,
        shortDescription: '',
        idList: [],
      }
    ]);
    const tableFolders = await this.getDirectory('folder', right, 190, 'FOLDER', prefix,'', [
      {
        '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
        type: 'FOLDER',
        name: null,
        reference: null,
        id: -1,
        shortDescription: '',
        idList: [],
      }
    ])
    tableFolders.forEach(folder => {
      if(folder.data.folderCount > 0 || folder.data.structureCount > 0) {
        folder.leaf = false
      }
    })
    allNodes[1].children = [...tableFolders, ...children1];
    this.setState({ allNodes: [...allNodes], expandedKeys: [] });
  }


  /** ********* methods for dialog ********************** */

  handleYes() {
    const { objectTable, objectTableNew, loc } = this.state;
    this.setState({
      visibleLoadSelect: false,
    });
    sessionStorage.setItem('evaluationRegional', loc);
    let objT = objectTable;
    if (loc === 'Land') {
      // return;
      objT = JsonHelper.deepCopy(objectTableNew); // causes error loading
    }
    this.loadNodeFinally(objT);
  }

  handleYesProd() {
    const { objectTable, objectTableNew, loc } = this.state;
    this.setState({
      visibleLoadSelect: false,
    });
    sessionStorage.setItem('evaluationRegional', loc);
    if (loc === 'Land') {
      this.loadNodeFinally(objectTableNew); // causes error loading
    } else {
      this.loadNodeFinally(objectTable);
    }
  }

  handleCancel() {
    this.setState({
      visibleLoadSelect: false,
      objectTable: undefined,
      objectTableNew: undefined,
    });
  }

  onHide() {
    this.setState({
      currentDialogType: DialogType.none,
      currentNode: undefined,
      newNodeDataName: undefined,
      selectedTreeNodeKey: undefined,
      entry1: undefined,
    });
  }

  setNewNodeDataName(name) {
    this.setState({ newNodeDataName: name });
  }

  /** *** methods for backend communication ****** */
  async getDirectory(type, right, objectNumber, objectTyp, prefix, typeString, links = [], selection = '') {
    const elementsData1 = await this.messageService.postVariableDirectory('directory', type, right, objectNumber, objectTyp, typeString, false, links, null, selection);
    const ch = []; // children
    if (elementsData1[0]) {
      let detail = elementsData1[0];
      let severity = elementsData1[1];
      if (elementsData1[2] !== 104) {
        this.growl.show({ severity, summary: `Hinweis zu ${TypeNames[type]}`, detail });
      }
      if (elementsData1[2] === -1) {
        //window.location.replace(`${process.env.PUBLIC_URL}/login`);
      }
    } else {
      const entries = elementsData1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      const { statisticsArray } = this.state;
      let statistic;
      for (let ii = 0; ii < entries.length; ii += 1) {
        // is statistic in statisticsArray?
        const sortDate = convertToSortable(entries[ii].modifiedDatabaseTime);
        const c = {};
        let isInStatistics = true;
        if (entries[ii].orderCriterionReference) {
          statistic = entries[ii].orderCriterionReference.statisticName;
          isInStatistics = statisticsArray.includes(statistic);
        }
        let rulename = '';
        if (entries[ii].shortDescription) {
          rulename = this.multiLanguage.returnInLanguage(entries[ii], 'de');
        }
        else {
          rulename = this.multiLanguage.returnLanguage(entries[ii].caption, 'de');
        }
        c.key = `${prefix}-${ii}`;
        c.type = type;
        c.objectNumber = objectNumber;
        c.subtype = entries[ii].type;
        c.data = {};
        c.data.name = entries[ii].name;
        c.data.rulename = rulename;
        c.data.targetVariable = entries[ii].targetVariable;
        c.data.typ = entries[ii].typ;
        c.data.date = entries[ii].modifiedDatabaseTime;
        c.data.sortDate = sortDate;
        c.data.owner = entries[ii]?.ownerInfo?.user;
        c.data.id = entries[ii].id;
        c.data.protection = entries[ii].protection;
        if( type === 'folder') {
          c.data.folderCount = entries[ii].folderCount;
          c.data.structureCount = entries[ii].structureCount;
          c.data.typ = 'folder';
        }
        if( type === 'folderAssociation')
          c.data.structureName = entries[ii].structureName
        c.leaf =true
        if (isInStatistics) ch.push(c);
      }
    }
    return ch;
  }

  returnFilterVariables = (filterVariables) => {
    let a;
    const ret = [];
    for (let i = 0; i < filterVariables.length; i += 1) {
      const filterValueNames = filterVariables[i].filterValue.map((obj) => obj.name).join(', ');
      const filterValueTexts = filterVariables[i].filterValue.map((obj) => obj.shortDescription.langText[0].text).join(', ');
      const counter = i === 0 ? '' : i + 1;
      a = (
        <>
          <div className="p-col-2 p-lg-2">
            <span className="p-float-label">
              <InputText disabled id="klassifikationen" defaultValue={filterVariables[i].filterVariableName} />
              <label htmlFor="klassifikationen1">{`Klassifikation ${counter}`}</label>
            </span>
          </div>
          <div className="p-col-2 p-lg-10">
            <span
              className="p-float-label"
              title={filterVariables[i].filterVariable.shortDescription.langText[0].text}
            >
              <InputText disabled id="klassifikationen1Text" defaultValue={filterVariables[i].filterVariable.shortDescription.langText[0].text} />
            </span>
          </div>
          <div className="p-col-2 p-lg-2">
            <span
              className="p-float-label"
              title={filterValueNames}
            >
              <InputText
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                disabled
                id="auspraegungen1"
                defaultValue={filterValueNames}
              />
              <label htmlFor="auspraegungen1">{`Ausprägungen ${counter}`}</label>
            </span>
          </div>
          <div className="p-col-2 p-lg-10">
            <span
              className="p-float-label"
              title={filterValueTexts}
            >
              <InputText
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                disabled
                id="auspraegungen1Text"
                defaultValue={filterValueTexts}
              />
            </span>
          </div>
        </>
      );
      ret.push(a);
    }
    return ret;
  }

  /*
  openDialogueDeprecated() {
    this.setState({ dialogueVisible: true });
  }
  */

  closeDialogue() {
    this.setState({ dialogueVisible: false });
  }

  async confirmDialog() {
    this.setState({ visibleWait: true });
    const {currentNode, currentDialogType, allNodes} = this.state;
    const {type} = currentNode;
    let success = false;
    const statistic = window.location.href.split('&')[1];
    const right = TableSavedNames[statistic][2];
    switch(currentDialogType) {
      case DialogType.delete:
        if(currentNode.parentId) {
          const result = await this.messageService.postVariableDirectory('directory', 'folderAssociation', right, 191, 'FOLDER_STRUCTURE_ASSOCIATION', '', false, [
            {
              '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
              type: 'FOLDER',
              name: null,
              reference: null,
              id: currentNode.parentId,
            },
            {
              '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
              type: 'STRUCTURE',
              name: null,
              reference: null,
              id: currentNode.data.id,
            }
          ], null, '');
          const folderAssociation = result?.data?.contents?.['genesis.container.content.GenesisTMContent']?.transfermodel?.entrys?.[0]
         
          await this.messageService.postFolderAssociationDelete(folderAssociation.id)
        }
        success = await this.deleteNode(currentNode);

        

        break;
      case DialogType.rename:
        success = await this.renameNode(currentNode, this.state.newNodeDataName)
        break;
      case DialogType.copyItem:
        success = await this.copyNode(currentNode, this.state.newNodeDataName)
        break;
      case DialogType.moveItem:
        // nocht nichts
        break;
      default:
    }
    if(success) {
      if(type === 'variable') {
        const children2 = await this.getDirectory('variable', right,
        '3', 'VARIABLE', '0');
        allNodes[0].children = children2;
        this.setState({allNodes})
      }
      
      if (type === 'variable' || type === 'rule') {
        // aktualisiere Regeln
        const statistic = window.location.href.split('&')[1];
        const right = TableSavedNames[statistic][2];
        const children2 = await this.getDirectory('rule', right,
        '34', 'RULE', '2');
        allNodes[2].children = children2;
        this.setState({allNodes})
      }

      if(type === 'structure')
        await this.reloadTablesAndFolders();
    }
    this.setState({ visibleWait: false });
    this.onHide()
  }

  openDialog(node, type, entry) {
    const newState = { currentDialogType: type, currentNode: node, entry1: entry };
    if (type === DialogType.rename) {
      newState.newNodeDataName = node.data.name;
    }
    this.setState(newState);
    const { name } = node.data;
    this.setState({ nodeName: name });
    if (type === DialogType.propertiesHr) {
      const { hierarchyLevels } = entry;

      const stepTemplate = {
        level: {
          name: '',
          longname: '',
          type: '',
        },
        target: {
          name: '',
          longname: '',
          type: '',
        },
        rule: {
          name: '',
          longname: '',
          type: '',
        },
      };

      const tabulated = hierarchyLevels.map(
        (e) => {
          const item = JsonHelper.deepCopy(stepTemplate);
          item.level.name = e.baseVariableReferences.name;
          item.level.longname = e.baseVariableReferences.shortDescription.langText[0].text;
          item.level.type = e.baseVariableReferences.type;
          item.target.name = e.targetVariableReferences.name;
          item.target.longname = e.targetVariableReferences.shortDescription.langText[0].text;
          item.target.type = e.targetVariableReferences.type;
          item.rule.name = e.referenceRuleReference.name;
          item.rule.longname = e.referenceRuleReference.shortDescription.langText[0].text;
          item.rule.type = e.referenceRuleReference.type;
          return ((
            <TabPanel header={item.level.name}>
              <br />
              <div className="p-grid p-fluid">
                <div className="p-col-2 p-lg-2">
                  <span className="p-float-label">
                    <InputText disabled id="name" defaultValue={item.level.name} />
                    <label htmlFor="name">Basismerkmal</label>
                  </span>
                </div>
                <div className="p-col-2 p-lg-6">
                  <span className="p-float-label">
                    <InputText disabled id="name" defaultValue={item.level.longname} />
                  </span>
                </div>
                <div className="p-col-2 p-lg-4">
                  <span className="p-float-label">
                    <InputText
                      disabled
                      id="name1"
                      defaultValue={this.returnType(item.level.type)}
                    />
                    <label htmlFor="name1">Typ</label>
                  </span>
                </div>
                <div className="p-col-2 p-lg-2">
                  <span className="p-float-label">
                    <InputText disabled id="name" defaultValue={item.target.name} />
                    <label htmlFor="name">Ergebnismerkmal</label>
                  </span>
                </div>
                <div className="p-col-2 p-lg-6">
                  <span className="p-float-label">
                    <InputText disabled id="name" defaultValue={item.target.longname} />
                  </span>
                </div>
                <div className="p-col-2 p-lg-4">
                  <span className="p-float-label">
                    <InputText disabled id="name1" defaultValue={this.returnType(item.target.type)} />
                    <label htmlFor="name1">Typ</label>
                  </span>
                </div>
                <div className="p-col-2 p-lg-2">
                  <span className="p-float-label">
                    <InputText disabled id="name" defaultValue={item.rule.name} />
                    <label htmlFor="name">Regel</label>
                  </span>
                </div>
                <div className="p-col-2 p-lg-6">
                  <span className="p-float-label">
                    <InputText disabled id="name" defaultValue={item.rule.longname} />
                  </span>
                </div>
                <div className="p-col-2 p-lg-4">
                  <span className="p-float-label">
                    <InputText disabled id="name1" defaultValue={this.returnType(item.rule.type)} />
                    <label htmlFor="name1">Typ</label>
                  </span>
                </div>
              </div>
            </TabPanel>
          )
          );
        },
      );

      const template = {
        key: '0',
        label: '',
        icon: 'pi pi-fw pi-star',
        children: [],
      };

      let child;
      let ruleStructure;
      let ruleStructureHr;
      let tmpString = '0';
      for (let j = 0; j < hierarchyLevels.length - 1; j += 1) {
        tmpString += '-0';
      }
      let tmpLong;
      let tmpShort;
      for (let i = hierarchyLevels.length; i > 0; i -= 1) {
        const itemHir = JsonHelper.deepCopy(template);
        itemHir.key = tmpString;
        if (type === DialogType.propertiesHr) {
          const long = this.multiLanguage.returnInLanguage(hierarchyLevels[i - 1].baseVariableReferences, 'de');
          const short = hierarchyLevels[i - 1].baseVariable;
          itemHir.label = `${long} (${short})`; // hierarchy
          tmpShort = hierarchyLevels[i - 1].targetVariable; // hierarchy
          tmpLong = this.multiLanguage.returnInLanguage(hierarchyLevels[i - 1].targetVariableReferences, 'de');
        } else {
          itemHir.label = hierarchyLevels[i - 1].referenceRule; // reference
        }
        if (child) itemHir.children[0] = child;
        child = itemHir;
        tmpString = tmpString.substring(0, tmpString.length - 2);
        ruleStructure = child;
        ruleStructureHr = child;
      }
      if (type === DialogType.propertiesHr) {
        const itemHirHr = JsonHelper.deepCopy(template);
        itemHirHr.label = `${tmpLong} (${tmpShort})`;
        itemHirHr.children[0] = child;
        ruleStructureHr = itemHirHr;
      }
      ruleStructure = [ruleStructure];
      ruleStructureHr = [ruleStructureHr];
      this.setState({ tabulated, ruleStructure, ruleStructureHr });
    }

    // #########################

    if (type === DialogType.propertiesAr) {
      // console.log('ENTRY#', entry);
      const { baseVariableReferences } = entry;
      const secondPage = [];
      for (let i = 0; i < baseVariableReferences.length; i += 1) {
        const { baseVariable } = baseVariableReferences[i];
        const { baseVariableReference } = baseVariableReferences[i];
        const { baseVariableStatistic } = baseVariableReferences[i];
        const { baseVariableStatisticReference } = baseVariableReferences[i];
        const { filterVariables } = baseVariableReferences[i];
        const { baseVariableMeasureUnitReference } = baseVariableReferences[i];
        const { formula } = baseVariableReferences[i];
        // const dispYear = baseVariableReferences[i].yearreference === null ? ' ' : baseVariableReferences[i].yearreference;
        secondPage.push(
          <TabPanel header={baseVariable}>
            <div><br /></div>
            <div className="p-grid p-fluid">
              <div className="p-col-2 p-lg-2">
                <span className="p-float-label">
                  <InputText disabled id="merkmale" defaultValue={baseVariable} />
                  <label htmlFor="merkmale">Merkmal</label>
                </span>
              </div>
              <div className="p-col-2 p-lg-10">
                <span className="p-float-label">
                  <InputText disabled id="MerkmaleText" defaultValue={baseVariableReference.shortDescription.langText[0].text} />
                </span>
              </div>
              <div className="p-col-2 p-lg-2">
                <span className="p-float-label">
                  <InputText disabled id="statistiken" defaultValue={baseVariableStatistic} />
                  <label htmlFor="statistiken">Statistik</label>
                </span>
              </div>
              <div className="p-col-2 p-lg-10">
                <span className="p-float-label">
                  <InputText disabled id="statistikenText" defaultValue={baseVariableStatisticReference.shortDescription.langText[0].text} />
                </span>
              </div>

              {this.returnFilterVariables(filterVariables)}
              <div className="p-col-2 p-lg-12">
                <span className="p-float-label">
                  <InputText disabled id="formel" defaultValue={formula} />
                  <label htmlFor="formel">Formel</label>
                </span>
              </div>
              <div className="p-col-2 p-lg-2">
                <span className="p-float-label">
                  <InputText disabled id="masseinheiten" defaultValue={baseVariableMeasureUnitReference.name} />
                  <label htmlFor="masseinheiten">Maßeinheit</label>
                </span>
              </div>
              <div className="p-col-2 p-lg-10">
                <span className="p-float-label">
                  <InputText
                    disabled
                    id="masseinheitenText"
                    defaultValue={dispMeasurement[baseVariableMeasureUnitReference.type]}
                  />
                </span>
              </div>
            </div>
          </TabPanel>,
        );
      }
      this.setState({ secondPage });
    }

    if (type === DialogType.propertiesRr) {
      // const { name, associationType } = entry1;
      // const { langText } = this.props.entry1.shortDescription;
      const { referenceItems } = entry;
      const labels = [];
      const ruleStructure = [];
      const template = {
        key: '0',
        label: '',
        icon: 'pi pi-fw pi-star',
        children: [],
      };
      let count = 0;
      for (let i = 0; i < referenceItems.length; i += 1) {
        const check = referenceItems[i].targetValue;
        const { baseValue } = referenceItems[i];
        if (!labels.includes(check)) {
          labels.push(check);
          const item = JsonHelper.deepCopy(template);
          item.key = count;
          item.label = check;
          ruleStructure.push(item);
          count += 1;
        }
        const position = labels.indexOf(check);
        const item = JsonHelper.deepCopy(template);
        item.key = `${position}-${ruleStructure[position].children.length}`;
        item.label = baseValue;
        ruleStructure[position].children.push(item);
      }
      this.setState({ ruleStructure });
    }
  }

  async deleteNode(node) {
    let success = true;
    const {objectNumber, type} = node;
    const {id} = node.data;
    const elementsData = await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false,
    );
    if (elementsData[0]) {
      success = false;
      this.growl.show({
        severity: elementsData[1],
        summary: 'Hinweis',
        detail: elementsData[0],
        life: 15000,
      });
    } else {
      const insertMessage = JsonHelper.deepCopy(elementsData);
      // remove selection from parameter-hashmap in message to prevent
      // searching for id instead of FachId which would work here
      insertMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.selektion = [];
      const link = 'delete';
      const ret = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false, undefined, insertMessage, link,
      );
      if (ret[0]) {
        if (ret[3] === 18128) {
          success = false;
          const message = ret[0];
          const confirmation = ret[2];
          confirmation.data.contents[
            'genesis.container.content.GenesisTMContent'
          ].menuRoot = null;
          // anzeigen Dialog
          this.setState({
            visibleYn: true,
            message,
            tmpNode: node,
            confirmation,
          });
        } else {
          success = false;
          const message = ret[0].replace('java.lang.Exception:', '');
          this.growl.show({
            severity: ret[1],
            summary: 'Hinweis',
            detail: message,
            life: 15000,
          });
        }
      } else {
        // nothing
      }
    }
    return success;
  }

  findNodeEnvironment(allNodes, nodeKey, startPos) {
    let start = 0;
    if (startPos) start = startPos;
    const splitNodeKey = nodeKey.split('-');
    let nodesArray = allNodes;
    const depth = splitNodeKey.length;

    for (let i = start; i < depth - 1; i += 1) {
      const output = nodesArray[splitNodeKey[i]].children;
      nodesArray = output;
    }
    const ret = { nodesArray, position: splitNodeKey[splitNodeKey.length - 1], depth };
    return ret;
  }

  updateKeyOfItemAndChildItems(nodesArray, startIndex, keyChangePosition) {
    let node;
    let oldKeySplit;
    const startNumber = Number(startIndex);
    for (let counter = startNumber; counter < nodesArray.length; counter += 1) {
      node = nodesArray[counter];
      oldKeySplit = node.key.split('-');
      oldKeySplit[keyChangePosition - 1] -= 1;
      node.key = oldKeySplit.join('-');
      if (node.children) {
        node.children = this.updateKeyOfItemAndChildItems(node.children, 0, keyChangePosition);
      }
    }
    return nodesArray;
  }

  async copyNode(node, newNodeDataName) {
    // copy and insert für Tabellen
    let success = true;
    const { id } = node.data;
    const { objectNumber, type } = node;
    const isPersonal = window.location.href.split('&')[1] === 'personal';
    const elementsData = await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false,
    );
    if (elementsData[0]) {
      this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
      success = false;
    } else {
      const insertMessage = elementsData;
      // im insert weiter unten eintragen
      // insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].name = newNodeDataName;
      let link = 'copy';
      // if (type === 'structure') link = 'updateLight'; // nur Tabellen, 2568
      let ret = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false, undefined, insertMessage, link,
      );
      if (ret[0]) {
        const message = ret[0].replace('java.lang.Exception:', '');
        this.growl.show({ severity: ret[1], summary: 'Hinweis', detail: message });
        success = false;
      } else {
        link = 'insert';
        ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].name = newNodeDataName;
        // ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].ownerInfo.rightArea = 'BEN';
        const retInsert = await this.messageService.postRecordStructureProperties(
          id, objectNumber, type, false, undefined, ret, link,
        );
        if (retInsert[0]) {
          const message = retInsert[0];
          // const message = ret[0].replace('java.lang.Exception:', '');
          this.growl.show({ severity: retInsert[1], summary: 'Hinweis', detail: message });
          success = false;
        } else {
          if (isPersonal) {
            // Tabellen reload
            const right = 'BEN';
            const ttype = 'structure';
            const objectTyp = 'STRUCTURE';
            const tobjectNumber = '108';
            const prefix = '1';
            const children1 = await this.getDirectory(ttype, right, tobjectNumber, objectTyp, prefix);
            const { allNodes } = this.state;
            allNodes[1].children = children1;
            this.setState({ allNodes });
          } else {
            this.growl.show({
              severity: 'success', summary: 'Hinweis', detail: 'Die Kopie wurde im Ihrem persönlichen Ordner erstellt.'
            });
          }
        }
      }
    }
    return success;
  }

  async renameNode(node, newNodeDataName) {
    let success = true;
    const { id } = node.data;
    const { objectNumber } = node;
    const { type } = node;
    
    const elementsData = await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false,
    );
    if (elementsData[0]) {
      this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
      success = false;
    } else {
      const insertMessage = elementsData;
      insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].name = newNodeDataName;
      let link = 'update';
      if (type === 'structure') link = 'updateLight'; // nur Tabellen, 2568
      const ret = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false, undefined, insertMessage, link,
      );
      if (ret[0]) {
        const message = ret[0].replace('java.lang.Exception:', '');
        this.growl.show({ severity: ret[1], summary: 'Hinweis', detail: message });
        success = false;
      }
    }
    return success;
  }

  iterateChilden(element, res, d) {
    let depth = d;
    const { children } = element;
    for (let n = 0; n < children.length; n += 1) {
      const { name, variableType, mutableVariablesReference } = children[n];
      const { length } = mutableVariablesReference;
      if (variableType === 'REGION_CLASSIFYING') {
        const notInArray = res.indexOf(name) === -1;
        const hasElements = length > 0;
        if (notInArray && hasElements) res.push(name);
      }
      if (children[n].children.length > 0) {
        depth += 1;
        this.iterateChilden(children[n], res, depth);
      }
    }
    return res;
  }

  iterateNames(structure) {
    let res = [];
    for (let i = 0; i < structure.length; i += 1) {
      res = this.iterateChilden(structure[i], res, 0);
    }
    return res;
  }

  async loadNode(node, loadTable) { // param currentNode
    // let success = true;
    let wasSwitchedToLand = false;
    let namesToChange = [];
    const arrRefItem = [];
    const arrNewItem = [];
    const { group } = this.state;
    const { typ, id } = node.data;
    const objectNumber = '108';
    const type = 'structure';
    const openDialog = (group !== 'StBA' && typ === 'DEFAULT'); // Standardtab.
    let state = '';
    if (openDialog) state = group.slice(group.length - 2, group.length);
    this.setState({ visibleWait: true });
    try {
      const elementsData = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false,
      );
      if (elementsData[0]) {
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
        // success = false;
      } else {
        const objectTableNew = JsonHelper.deepCopy(elementsData); // set for 'Land'
        const objectTable = JsonHelper.deepCopy(elementsData); // new selected set
        const { entrys } = objectTableNew.contents['genesis.container.content.GenesisTMContent'].transfermodel; // TODO check if New can be deteted
        const jsonStructure = JSON.parse(entrys[0].jsonStructure);
        const selectedRegional = jsonStructure.selectedRegional
        sessionStorage.setItem('loadTable', loadTable);
        if (openDialog) {
          // get all possible values
          const { structureAxis } = elementsData.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0];
          const newStructureAxis = JsonHelper.deepCopy(structureAxis);
          // Namen rekursiv
          namesToChange = this.iterateNames(structureAxis);
          const landPrefix = group.slice(group.length - 2, group.length);
          // end Namen
          for (let i = 0; i < structureAxis.length; i += 1) {
            for (let j = 0; j < structureAxis[i].children.length; j += 1) {
              const { mutableVariablesReference } = structureAxis[i].children[j];
              if (mutableVariablesReference.length > 1) {
                arrRefItem[arrRefItem.length] = mutableVariablesReference[0];
                for (let k = 0;
                  k < mutableVariablesReference.length;
                  k += 1) {
                  const refName = mutableVariablesReference[k].name;
                  if (refName.substring(0, 2) === state) {
                    for (let m = 0; m < changeVariables.length; m += 1) {
                      if(jsonStructure[changeVariables[m]])
                        if (jsonStructure[changeVariables[m]].length !== 0) {
                          for (let n = 0; n < jsonStructure[changeVariables[m]].length; n += 1) {
                            if (jsonStructure[changeVariables[m]][n].type === 'REGION_CLASSIFYING') {
                              if (jsonStructure[changeVariables[m]][n].mutableVariablesReference.length > 0) {
                                wasSwitchedToLand = true;
                                const test = mutableVariablesReference[k];
                                test['@class'] = 'genesis.transfer.model.dto.display.StructureElementDTO';
                                // Austauschen
                                jsonStructure[changeVariables[m]][n] = mutableVariablesReference[k];
                                // Filter, Regeln löschen
                                // ...
                              }
                            }
                          }
                        }
                    }
                    const tmpRef = JsonHelper.deepCopy(newStructureAxis[i].children[j]);
                    const tmpLand1 = JsonHelper.deepCopy(mutableVariablesReference[k]);
                    const tmpLand = tmpRef;
                    tmpLand.name = refName;
                    tmpLand.formatings.name = refName;
                    tmpLand.output[0].name = refName;
                    tmpLand.output[0].reference = tmpLand1;
                    tmpLand.mutableVariablesReference = [];
                    wasSwitchedToLand = true;
                    // TODO selection entfernen
                    delete tmpLand.topic;
                    const replaceNode = tmpLand;
                    arrNewItem[arrNewItem.length] = tmpLand; // TODO check
                    newStructureAxis[i].children[j] = replaceNode;
                  }
                }
              }
            }
          }
          objectTableNew.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].structureAxis = newStructureAxis;
          objectTableNew.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].structureAxis = newStructureAxis;
          sessionStorage.setItem('evaluationRegional', selectedRegional);
          const { selectedStatistics } = jsonStructure;
          const st = [];
          for (let j = 0; j < selectedStatistics.length; j += 1) {
            st.push(selectedStatistics[j].name);
          }
          sessionStorage.setItem('evaluationStatistics', st); // selectedStatistics als array
          this.setState({
            loc,
            locs,
            objectTable,
            objectTableNew,
            visibleLoadSelect: true,
            arrRefItem,
            arrNewItem,
            wasSwitchedToLand,
            namesToChange,
            landPrefix,
          });
        } else {
          sessionStorage.setItem('evaluationRegional', selectedRegional);
          // jsonStructure.tableRendered = { nothing: `id${(new Date()).getTime()}`};+
          const { selectedStatistics } = jsonStructure;
          const st = [];
          for (let j = 0; j < selectedStatistics.length; j += 1) {
            st.push(selectedStatistics[j].name);
          }
          sessionStorage.setItem('evaluationStatistics', st); // selectedStatistics als array
          await this.loadNodeFinally(objectTable);
        }
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error in loadNode: ', err);
    } finally {
      this.setState({ visibleWait: false });
    }
    // return success;
  }

  async preloadTableCheck(loadedTable) {
    let tree;
    let loadedTableSt = loadedTable.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0];
    loadedTableSt = JsonHelper.deepCopy(loadedTableSt);
    if (loadedTableSt.typ === 'DEFAULT') {
      loadedTableSt.typ = 'STRUCTURE';
    }
    const tableTyp = loadedTableSt.typ;
    let firstDataSuccess = true;
    const { jsonStructure } = loadedTableSt;
    if (jsonStructure === null) {
      firstDataSuccess = false;
    } else {
      const loadedStructure = JSON.parse(loadedTableSt.jsonStructure);
      loadedStructure.tableTyp = tableTyp;
      delete loadedStructure.saveTableVisible;
      const { valueEmptyLines } = loadedStructure;
      console.log('VALUEEMPTYLINES#', loadedStructure);
      let { value } = loadedStructure;
      this.setState({ visibleWait: true });
      if (typeof value === 'undefined') value = this.state.value;
      const retrievalObj = {
        link: 'valueretrieval',
        tree,
        loadedTable,
        notShowSecretValues: value,
        zusatzfilter: ["json"],
      };
      const returnMessage = await this.messageService.postValueRetrievalStart(retrievalObj);
      this.setState({ visibleWait: false });
      if (returnMessage[1] === 'error') {
        const errNum = returnMessage[2];
        const checkError = returnMessage[0];
        let displayError = 'Ein unbekannter Fehler ist aufgetreten.';
        if (errNum === 7000) {
          displayError = 'Tabelle nicht mehr abrufbar (verwendete Regel oder Daten nicht mehr vorhanden)';
        } else if (errNum === 1191 || errNum === 1193 || errNum === 1194) {
          displayError = 'Tabelle ist nicht mehr abrufbar';
        } else if (checkError === 'javax.ejb.EJBTransactionRolledbackException: genesis.transfer.model.dto.RetrievalJobDTO cannot be cast to genesis.transfer.model.gom.GOMContainer') {
          // displayError = 'Die Anfrage liefert zu viele Werte zurück.';
          displayError = checkError;
        } else {
          displayError = checkError;
        }
        //ADBHSSTAT-2832 Fehlermeldung wird nicht angezeigt, da bereits auf Statistics navigiert wurde (Statistics hat einen eigenen Growl).
        this.growl.show({
          life: 12000,
          severity: returnMessage[1],
          summary: 'Fehler',
          detail: displayError,
        });
        firstDataSuccess = false;
      }
    }
    return firstDataSuccess;
  }

  async loadNodeFinally(objectTable) {
    const {
      arrRefItem,
      arrNewItem,
      wasSwitchedToLand,
      namesToChange,
      landPrefix,
    } = this.state;
    const doNotLoadValues = false;
    const loadedTable = objectTable;
    let cont;
    try {
      this.setState({ visibleWait: true });
      cont = await this.preloadTableCheck(loadedTable);
    } catch (err) {
      console.log('error in loadNodeFinally', err, cont);
    } finally {
      this.setState({ visibleWait: false });
      // return; // TODO remove
      this.props.history.push({
        pathname: '/evaluation/statistics',
        state: {
          loadedTable: objectTable,
          arrRefItem,
          arrNewItem,
          wasSwitchedToLand,
          namesToChange,
          landPrefix,
        },
      });
    }
  }

  async viewProperties(node) {
    let isVariable = false; // rule and variable don't have the same heading
    if (node.type === 'rule') {
      // node: hier gibt es data.id und data.name
      const { name, id } = node.data;
      const path = 'properties';
      const inputType = 'rule';
      // Eingenschaften abrufen
      const elementsData = await this.messageService.postRuleProperties(path, inputType, name, id);
      if (elementsData[0]) {
        const message = elementsData[0].replace('java.lang.Exception:', '');
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: message });
      } else {
        const { entrys } = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
        const entry = entrys[0];
        const { type } = entry;
        const kind = ruleType[type];
        this.openDialog(node, kind, entry);
      }
    } else if (node.type === 'variable') {
      isVariable = true;
      // für Eigenschaften W-MM
      const { name, id } = node.data;
      const path = 'propertiesFormAssociatedVariable';
      const inputType = 'rule';
      // Eingenschaften abrufen
      const elementsData = await this.messageService.postVariableProperties(path,
        inputType, name, id);
      if (elementsData[0]) {
        let message = elementsData[0].replace('java.lang.Exception:', '');
        if (message === 'Es gibt noch keine Objekte.') {
          message = 'Zu diesem Merkmal ist keine Regel vorhanden.';
        }
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: message });
      } else {
        const { entrys } = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
        const entry = entrys[0];
        const { type } = entry;
        const kind = ruleType[type];
        console.log('NODE#', node, kind, entry);
        this.openDialog(node, kind, entry);
      }
    } else if (node.type === '') {
      // nothing yet
    }
    this.setState({ isVariable });
  }

  returnType = (type) => dispType[type]

  async loadStatisticList(returnMessage) {
    const statisticsList = await this.messageService.postStatisticDirectory(returnMessage);
    const statisticsArray = [];
    for (let i = 0; i < statisticsList.length; i += 1) {
      statisticsArray[i] = statisticsList[i].name;
    }
    this.setState({
      statisticsArray,
    });
  }

  /** **** methods for component rendering **** */
  actionTemplate(node) {
    const role = sessionStorage.getItem('role');
    const isAdmin = role === 'GROUP_ADMIN';
    const isSysAdmin = role === 'SYSTEM_ADMIN';
    const isSuperAdmin = role === 'SUPER_SUBJECT_ADMIN';
    const isPersonal = window.location.href.split('&')[1] === 'personal';
    const isGroup = window.location.href.split('&')[1] === 'shared';
    const { type } = node;
    const isStructure = type === 'structure';
    const isGroupStructure = isStructure && isGroup;
    const showEditAndDelete = isAdmin || isSysAdmin || isPersonal || isSuperAdmin || isGroupStructure;
    const showEditAndDeleteFolder = isPersonal || (isGroup && (isAdmin || isSysAdmin || isSuperAdmin)) || isSuperAdmin
    const showMove = (isAdmin || isSysAdmin || isPersonal || isSuperAdmin || isGroupStructure) && isStructure;
    const showCopy = (isAdmin || isSysAdmin || isPersonal || isSuperAdmin || isGroupStructure) && isStructure;
    const showSubFolder = showEditAndDeleteFolder && type === 'folder';
    const { protection } = node.data;
    const readonly = (protection === 'READ');
    return (
      <div>
        {!node.selectable ? (
          <span>
            {node.type === "structure" ? (
              <Button
                id="openStructure"
                title="Tabellenstruktur öffnen"
                type="button"
                icon="pi-md-play-arrow"
                className="p-button-success"
                onClick={() => this.loadNode(node, "false")}
              />
            ) : undefined}
            {node.type === "structure" ? (
              <Button
                id="open"
                title="Tabelle öffnen"
                type="button"
                icon="pi-md-arrowstop-1-e"
                className="p-button-success"
                onClick={() => this.loadNode(node, "true")}
              />
            ) : undefined}
            {node.type === "variable" ? (
              <Button
                id="properties"
                title="Eigenschaften anzeigen"
                onClick={() => this.viewProperties(node)}
                type="button"
                icon="pi pi-md-web-asset"
                className="p-button-warning"
              />
            ) : undefined}
            {node.type === "rule" ? (
              <Button
                id="properties"
                title="Eigenschaften anzeigen"
                onClick={() => this.viewProperties(node)}
                type="button"
                icon="pi pi-md-web-asset"
                className="p-button-warning"
              />
            ) : undefined}
            {showSubFolder ? (
              <span>
                <Button
                  type="button"
                  icon="pi-md-create-new-folder"
                  title="Neuer Unterordner"
                  className="p-button-success"
                  onClick={() => this.openFolderDialog(FolderDialogTypes.newSubFolder, node)}
                />
              </span>
            ) : undefined}
            {(type === 'folder' ? showEditAndDeleteFolder : showEditAndDelete) ? (
              <Button
                disabled={readonly}
                id="rename"
                title="Umbenennen"
                type="button"
                icon="pi-md-edit"
                className="p-button-info"
                onClick={() => {
                  if(node.type !== "folder")
                    this.openDialog(node, DialogType.rename)
                  else
                    this.openFolderDialog(FolderDialogTypes.renameFolder, node)
                }}
              />
            ) : undefined}
            {showMove ? (
              <Button
                disabled={readonly}
                id="move"
                title="Verschieben"
                type="button"
                icon="pi-md-open-with"
                className="p-button-info"
                onClick={() => this.openFolderDialog(FolderDialogTypes.moveTableToFolder, node)}
              />
            ) : undefined}
            {showCopy ? ( // Kopieren wird später implementiert
              <Button
                id="copy"
                title="Kopieren"
                type="button"
                icon="pi-md-content-copy"
                className="p-button-info"
                onClick={() => {
                  if(node.type !== "folder")
                    this.openDialog(node, DialogType.copyItem)
                  else
                    this.openFolderDialog(FolderDialogTypes.copyFolder, node)
                }}
              />
            ) : undefined}
            {(type === 'folder' ? showEditAndDeleteFolder : showEditAndDelete) ? (
              <Button
                disabled={readonly}
                id="delete"
                title="Löschen"
                type="button"
                icon="pi-md-delete-forever"
                className="p-button-danger"
                onClick={() => {
                  if(node.type !== "folder")
                    this.openDialog(node, DialogType.delete)
                  else
                    this.openFolderDialog(FolderDialogTypes.deleteFolder, node)
                }}
              />
            ) : undefined}
          </span>
        ) : (node.data.name === 'Tabellen' && showEditAndDeleteFolder) ? (
          <span>
            <Button
              type="button"
              icon="pi-md-create-new-folder"
              title="Neuer Unterordner"
              className="p-button-success"
              onClick={() => this.openFolderDialog(FolderDialogTypes.newFolder, node)}
            />
          </span>
        ) : undefined}
      </div>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  typeTemplate(node) {
    return (
      node.data.typ === 'DEFAULT' ? (
        
        <span style={{wordWrap: "anywhere", display: "flex"}}>
          {node.data.name}
          <i title="Standardtabelle" className="pi pi-md-local-offer" />
        </span>
      ) : node.type === 'folder' ? (
        <span style={{wordWrap: "anywhere", display: "flex"}}>
          <i title="Ordner" className="pi pi-md-folder" style={{
            "verticalAlign": "text-bottom"
          }} />
          {node.data.name}
        </span>
        ) :  <span style={{wordWrap: "anywhere", display: "flex"}}>{node.data.name}</span>
    );
  }

  launchStatistics(structure) {
    const { history } = this.props;
    history.push({
      pathname: '/evaluation/statistics',
      state: {
        loadedTable: structure,
      },
    });
  }

  async confirmYnDialog() {
    const {
      newNodeDataName, tmpNode, confirmation
    } = this.state;
    let success = true;
    const { data } = confirmation;
    let ret;
    this.setState({ visibleYn: false, visibleWait: true });
    let { allNodes } = this.state;
    const { key } = tmpNode;
    const currentNodeEnvironment = this.findNodeEnvironment(allNodes, key);
    let { nodesArray } = currentNodeEnvironment;
    const node = nodesArray[currentNodeEnvironment.position];
    const { type } = tmpNode;
    try {
      ret = await this.messageService.postRecordStructureDelete(data, type);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('ERROR in confirmYnDialog', err);
      success = false;
    }
    if (ret[0]) {
      success = false;
      const message = ret[0].replace('java.lang.Exception:', '');
      this.growl.show({ severity: ret[1], summary: 'Hinweis', detail: message });
    }
    if (success) {
      // Zeile löschen im FE
      nodesArray.splice(currentNodeEnvironment.position, 1);
      if (newNodeDataName) node.data.name = newNodeDataName;
      const nodesArrayA = JsonHelper.deepCopy(nodesArray);
      const res = this.updateKeyOfItemAndChildItems(
        nodesArrayA, currentNodeEnvironment.position, currentNodeEnvironment.depth,
      );
      nodesArray = res;
      allNodes = JsonHelper.deepCopy(allNodes);
      allNodes[TypeNumbers[type]].children = nodesArray;
      if (type === 'variable' || type === 'rule') {
        // aktualisiere Regeln
        const statistic = window.location.href.split('&')[1];
        const right = TableSavedNames[statistic][2];
        const refreshType = 'rule';
        const objectTyp = 'RULE';
        const objectNumber = '34'; // VARIABLE=3, RULE=34, STRUCTURE=108
        const prefix = '2';
        const children2 = await this.getDirectory(refreshType, right,
          objectNumber, objectTyp, prefix);
        allNodes[2].children = children2;
      }
    }
    this.setState({ allNodes, visibleWait: false }); // FE update
  }

  renderYnFooter() {
    // const { onHide, confirmDialog } = this.props;
    return (
      <div>
        <Button
          id="yes"
          label="Ja"
          icon="pi pi-check"
          onClick={() => this.confirmYnDialog()}
        />
        <Button
          id="no"
          label="Nein"
          className="p-button-danger"
          icon="pi pi-times"
          onClick={() => this.setState({ visibleYn: false })}
        />
      </div>
    );
  }

  returnDropdowns() {
    const {
      loc, locs,
    } = this.state;
    const returnHtml = (
      <div className="card">
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-12">
            <div className="p-col-12 p-lg-12">
              <b>
                Bitte wählen Sie die Region aus, für die Sie die Standardtabelle öffnen möchten.
              </b>
            </div>
            <div className="p-col-12 p-lg-12">
              <Dropdown value={loc} options={locs} onChange={(e) => { this.setState({ loc: e.value }); }} placeholder="Regionalauswahl" />
            </div>
          </div>
        </div>
      </div>
    );
    return returnHtml;
  }

  renderFooter() {
    return (
      <div>
        <Button
          id="continue"
          label="Öffnen"
          icon="pi pi-check"
          onClick={() => this.handleYes()}
        />
        <Button
          id="cancel"
          label="Abbrechen"
          className="p-button-danger"
          icon="pi pi-times"
          onClick={() => this.handleCancel()}
        />
      </div>
    );
  }

  sortTemplate(node) {
    return node.data.date;
  }

  openFolderDialog(dialogType, currentNode) {
    this.setState({folderDialogType: dialogType, currentNode, isNewFolderDialogOpen: true});
  }

  async onFolderDialogConfirm(newName, targetFolder = null) {
    const { folderDialogType, currentNode } = this.state;
    const statistic = window.location.href.split('&')[1];
    const right = TableSavedNames[statistic][2];
    const folderInit = JsonHelper.deepCopy(this.state.folderInit);

    if(folderDialogType === FolderDialogTypes.newFolder) {
      const response = await this.messageService.postFolderInsert(newName, folderInit, right)
      if(response?.data?.contents['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message)
        this.growl.show({severity: "error", detail: response?.data?.contents[
          'genesis.container.content.GenesisNotificationContent'
        ]?.notifications?.[0]?.message})
    }
    if(folderDialogType === FolderDialogTypes.newSubFolder) {
      folderInit.contents['genesis.container.content.GenesisTMContent'].transfermodel.parentFolderName = currentNode.data.name;
      folderInit.contents['genesis.container.content.GenesisTMContent'].transfermodel.parentId = currentNode.data.id;
      const response = await this.messageService.postFolderInsert(newName, folderInit, right);
      if(response?.data?.contents['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message)
        this.growl.show({severity: "error", detail: response?.data?.contents[
          'genesis.container.content.GenesisNotificationContent'
        ]?.notifications?.[0]?.message})
    }

    if(folderDialogType === FolderDialogTypes.deleteFolder) {
      const response = await this.messageService.postFolderDelete(currentNode.data.id)
      if (response.number) {
        const message = response.message;
        const number = response.number;
        const severity = response.severity;
        if(number === 18130) {
          this.openFolderDialog(FolderDialogTypes.confirmDelete, currentNode)
          const confirmation = response.content;
          confirmation.data.contents[
            'genesis.container.content.GenesisTMContent'
          ].menuRoot = null;
          this.setState({
            message,
            confirmation,
          });  
        }
        else {
          this.growl.show({
            life: 12000,
            severity: severity,
            summary: 'Fehler',
            detail: message,
          });
        }
        return;
      }
    }

    if(folderDialogType === FolderDialogTypes.confirmDelete) {
      const { data } = this.state.confirmation;
      await this.messageService.postMessage(data, 'folder/delete', 'postFolderDelete');
    }

    if(folderDialogType === FolderDialogTypes.copyFolder) {
      const result = await this.messageService.postFolderProperties(currentNode.data.id);
    }

    if(folderDialogType === FolderDialogTypes.renameFolder) {
      const result = await this.messageService.postFolderUpdate(newName, currentNode.data.id, folderInit);
      if(result?.data?.contents['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message)
        this.growl.show({severity: "error", detail: response?.data?.contents[
          'genesis.container.content.GenesisNotificationContent'
        ]?.notifications?.[0]?.message})
    }

    if(folderDialogType === FolderDialogTypes.moveTableToFolder) {
      if(currentNode.parentId) {
        const result = await this.messageService.postVariableDirectory('directory', 'folderAssociation', right, 191, 'FOLDER_STRUCTURE_ASSOCIATION', '', false, [
          {
            '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
            type: 'FOLDER',
            name: null,
            reference: null,
            id: currentNode.parentId,
          },
          {
            '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
            type: 'STRUCTURE',
            name: null,
            reference: null,
            id: currentNode.data.id,
          }
        ], null, '');
        const folderAssociation = result?.data?.contents?.['genesis.container.content.GenesisTMContent']?.transfermodel?.entrys?.[0]
        if(targetFolder) {
          const init = JsonHelper.deepCopy(this.state.folderAssociationInit);

          const response = await this.messageService.postFolderAssociationUpdate(targetFolder.data.id, targetFolder.data.name, currentNode.data.id, currentNode.data.name, folderAssociation.id, init);
          if(response?.data?.contents['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message)
          this.growl.show({severity: "error", detail: response?.data?.contents[
            'genesis.container.content.GenesisNotificationContent'
          ]?.notifications?.[0]?.message})
        }
        else {
          const response = await this.messageService.postFolderAssociationDelete(folderAssociation.id)
          if(response?.data?.contents['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message)
          this.growl.show({severity: "error", detail: response?.data?.contents[
            'genesis.container.content.GenesisNotificationContent'
          ]?.notifications?.[0]?.message})
        }
      }
      else {
        if(targetFolder) {
          const tmp = JsonHelper.deepCopy(this.state.folderAssociationInit);
          tmp.contents['genesis.container.content.GenesisTMContent'].transfermodel.folderIdent = targetFolder.data.id
          tmp.contents['genesis.container.content.GenesisTMContent'].transfermodel.folderName = targetFolder.data.name
          tmp.contents['genesis.container.content.GenesisTMContent'].transfermodel.structureIdent = currentNode.data.id
          tmp.contents['genesis.container.content.GenesisTMContent'].transfermodel.structureName = currentNode.data.name
          const response = await this.messageService.postFolderAssociationInsert(tmp, {...folderInit.ownerInfo, rightArea: right});
          if(response?.data?.contents['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message)
          this.growl.show({severity: "error", detail: response?.data?.contents[
            'genesis.container.content.GenesisNotificationContent'
          ]?.notifications?.[0]?.message})
        }
      }
    }

    /* switch(folderDialogType){
      case FolderDialogTypes.deleteFolder:
        await this.reloadFoldersWithId(allNodes, currentNode.parentId)
        break;
      case FolderDialogTypes.renameFolder:
        await this.reloadFoldersWithId(allNodes, currentNode.parentId)
        break;
      case FolderDialogTypes.newSubFolder:
        await this.reloadFoldersWithId(allNodes, currentNode.data.id)
        break;
      case FolderDialogTypes.moveTableToFolder:
        if(currentNode.parentId) await this.reloadFoldersWithId(allNodes, currentNode.parentId)
        await this.reloadFoldersWithId(allNodes, targetFolder.data.id)
        break;
      default:
        await this.reloadTablesAndFolders();
        break;
    } */

   /*  if(currentNode.parentId) {
      if()
      await this.reloadFoldersWithId(allNodes, currentNode.parentId)
    }
     */
   await this.reloadTablesAndFolders();
   //this.setState({foldersLoading: false})
  // this.setState({ visibleWait: false });
   
  }

  async reloadFoldersWithId(nodes, id) {
    for(let i = 0; i < nodes.length; i++) {
      if(nodes[i].data.id === id)
        await this.loadSubFoldersAndTables(nodes[i])
      else
        if(nodes[i].children)
        await this.reloadFoldersWithId(nodes[i].children, id)
    }
  }

  async onFolderExpand(e) {
    if(!e.node.children) this.loadSubFoldersAndTables(e.node)
  }

  async loadSubFoldersAndTables(node) {
    const statistic = window.location.href.split('&')[1];
    const right = TableSavedNames[statistic][2];
    const prefix = '1';
    const { allNodes } = this.state
    const children = [];
    

    if(node.data.folderCount > 0 ) {
      const subFolders = await this.getDirectory('folder', right, 190, 'FOLDER', prefix,'', [
        {
          '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
          type: 'FOLDER',
          name: null,
          reference: null,
          id: node.data.id,
          shortDescription: '',
          idList: [],
        }
      ])
      subFolders.forEach(folder => {
        folder.parentId = node.data.id
        if(folder.data.folderCount > 0 || folder.data.structureCount > 0)
          folder.leaf = false
      })

      children.push(...subFolders)
      
    }

    if(node.data.structureCount > 0 ) {
      const tables = await this.getDirectory('structure', right, '108', 'STRUCTURE', prefix,'', 
      [{
        '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
        type: 'FOLDER',
        name: null,
        reference: null,
        id: node.data.id,
        shortDescription: '',
        idList: [],
        
          }]
        );

        tables.forEach(table => {
          table.parentId = node.data.id
      })

      children.push(...tables)
    }

    node.children = children
    this.setState({allNodes})
  
  }

  cleanUpNodeKeys (nodes, parent = null) {
    for(let i = 0; i < nodes.length; i++) {
        let key = i;
        if(parent !== null) key = `${parent}`.concat(`-${i}`)
        nodes[i].key = key
        if(nodes[i].children) this.cleanUpNodeKeys(nodes[i].children, key)
    }
}

  render() {
    const statistic = window.location.href.split('&')[1];
    const {
      entry1,
      secondPage,
      tabulated,
      ruleStructure,
      ruleStructureHr,
      currentNode,
      currentDialogType,
      visibleWait,
      visibleYn,
      visibleLoadSelect,
      message,
      allNodes,
      selectedTreeNodeKey,
      newNodeDataName,
      dialogueVisible,
      nodeName,
      isVariable,
      selectedCategory,
      isNewFolderDialogOpen
    } = this.state;
    const dspCategory = selectedCategory || 'Regionalauswahl';
    const selectedStatistics = '';
    const elements = '';
    this.cleanUpNodeKeys(allNodes)
    return (
      <>
        <Growl ref={(el) => { this.growl = el; }} />
        <Dialog header="Lade Daten..." closable={false} closeOnEscape={false} visible={visibleWait} modal onHide={() => this.setState({ visibleWait: false })}>
          <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
        </Dialog>
        <Dialog
          header="Löschen"
          closeOnEscape={false}
          visible={visibleYn}
          modal
          onHide={() => this.setState({ visibleYn: false })}
          footer={this.renderYnFooter()}
        >
          <div><p><h3>{message}</h3></p></div>
        </Dialog>
        {/* This Dialogue is a placeholder for selection of years etc. in standard tables */}
        <Dialog
          header={dspCategory}
          visible={visibleLoadSelect}
          style={{ width: '30vw' }}
          footer={this.renderFooter()}
          onHide={() => this.onHide()}
          modal
        >
          {this.returnDropdowns()}
        </Dialog>

        <FolderDialog
          visible={isNewFolderDialogOpen}
          onHide={() => this.setState({isNewFolderDialogOpen: false})}
          type={this.state.folderDialogType}
          selectedFolder={currentNode}
          onConfirm={this.onFolderDialogConfirm}
          message={this.state.message}
          right={TableSavedNames[statistic][2]}
        />

        <div>
          <div id="evaluation">
            <h2>{TableSavedNames[statistic][0]}</h2>
          </div>
          <div>
            <TreeTable
              value={allNodes}
              onExpand={this.onFolderExpand}
              loading={this.state.foldersLoading}
              expandedKeys={this.state.expandedKeys}
              onToggle={(e) => {this.setState({expandedKeys: e.value})}}
              //style={{tableLayout: "auto"}}
             //scrollable
            >
              <Column
                body={this.typeTemplate}
                header="Ordner-/Objektname"
                expander
                style={{ width: "15rem" }} 
                className="objektname"
              />
              <Column
                field="rulename"
                header="(Beschreibung)"
                filterMatchMode='contains'
                sortable
                filter
                filterPlaceholder="In Regelname suchen"
                style={{ width: "15rem", textWrap: "auto" }} 
              />
              <Column
                field="targetVariable"
                header="(Ergebnismerkmal)"
                filterMatchMode='contains'
                sortable
                filter
                filterPlaceholder="In Erg.merkmal suchen"
                style={{ width: "15rem" }} 
              />
              <Column
                field="sortDate"
                header="letzte Änderung"
                filterMatchMode='contains'
                sortable
                filter
                filterPlaceholder="In Änderungsdat. suchen"
                style={{ width: "15rem" }} 
              />
              <Column
                field="owner"
                header="Eigentümer"
                filterMatchMode='contains'
                sortable
                filter
                filterPlaceholder="In Eigent. suchen"
                style={{ width: "15rem" }} 
              />
              <Column
                header="Aktionen"
                body={this.actionTemplate}
                style={{ width: "15rem" }} 
              />
            </TreeTable>
            <TablesSavedDialog
              tabulated={tabulated}
              ruleStructure={ruleStructure}
              ruleStructureHr={ruleStructureHr}
              secondPage={secondPage}
              entry1={entry1}
              nodeName={nodeName}
              onHide={this.onHide}
              currentDialogType={currentDialogType}
              confirmDialog={this.confirmDialog}
              returnType={this.returnType}
              selectedTreeNodeKey={selectedTreeNodeKey}
              isVariable={isVariable}
              newNodeDataName={newNodeDataName}
              setNewNodeDataName={this.setNewNodeDataName}
              currentNode={currentNode}
              allNodes={allNodes}
            />
            <ValueDialogRead
              header="Wertmerkmal"
              closeOnEscape
              visible={dialogueVisible}
              modal
              onHide={() => this.setState({ dialogueVisible: false })}
              closeDialogue={this.closeDialogue}
              selectedStatistics={selectedStatistics}
              elements={elements}
            />
          </div>
        </div>
      </>
    );
  }
}
